import { render, staticRenderFns } from "./PassengerDetailsEditor.vue?vue&type=template&id=9c890246"
import script from "./PassengerDetailsEditor.vue?vue&type=script&lang=ts"
export * from "./PassengerDetailsEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports